<template>
  <v-row align="center" justify="center" class="text-h6">
    <v-col>
      <div data-test-name="date">{{ date || '--' }}</div>
      <br />
      <div data-test-name="interval">{{ interval || '--' }}</div>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ClockComponent',
  props: {
    date: { type: String, default: '' },
    interval: { type: String, default: '' }
  }
});
</script>
